(ns app.front.view.group.admin.fees.util.fee-structure
  (:require [potpuri.core :as p]))

(defn resolve-templates-for-fee-structure
  "Recursively travel along the FeeStructure hierarchy looking for a FeeStructure that
  would match the given group-config-ids path and return the matching FeeStructure (if it exists)
  and a list of FeeTemplate IDs that belong to its parent hierarchy"
  [fee-structures group-config-ids parent-templates]
  (let [current-target  (first group-config-ids)
        rest-of-targets (rest group-config-ids)
        match           (p/find-first fee-structures
                                      #(= (:db/id (:fee-structure/target-group-config %)) current-target))]
    (if (some? match)
      (if (empty? rest-of-targets)
        [match parent-templates]
        (let [parent-fee-templates (->> match
                                        :fee-structure/fee-templates
                                        (map :db/id)
                                        (concat parent-templates))]
          (resolve-templates-for-fee-structure (:entity/_parent match) rest-of-targets parent-fee-templates)))
      [nil parent-templates])))


(defn resolve-unsaved-fee-structure-changes
  "Collect all unsaved changes from a target path for saving to the backend"
  [unsaved-changes group-config-ids]
  (let [{:keys [additions removals]} (reduce (fn [{:keys [path additions removals]} curr]
                                               (let [current-path (conj path curr)
                                                     changes      (p/find-first unsaved-changes
                                                                                #(= (:target-group-config-ids %)
                                                                                    current-path))]
                                                 {:additions (concat additions (:add changes))
                                                  :removals  (concat removals (:remove changes))
                                                  :path      current-path}))
                                             {:additions #{} :removals #{} :path []}
                                             group-config-ids)]
    {:add    (->> additions (remove nil?))
     :remove (->> removals (remove nil?))}))
